var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"afdf1f1875b3c2e9fb2c09638b28606e6d9ca62d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["coddee@kidow"]={id:"afdf1f1875b3c2e9fb2c09638b28606e6d9ca62d"};
      